export default __webpack_public_path__ + "static/media/ice.473ff566.png";